import React from "react"
import './animals.scss';
import Dinomascoto from '../../assets/dinos/Dinomascoto.png';
import Brachiosaurio from '../../assets/dinos/Brachiosaurio.png';
import Triceratopodo from '../../assets/dinos/Triceratopodo.png';
import Estegosaurio from '../../assets/dinos/Estegosaurio.png';
import AlejosaurioRex from '../../assets/dinos/AlejosaurioRex.png';
import Pterodactilo from '../../assets/dinos/Pterodactilo.png';
import Deinonychus  from '../../assets/dinos/Velocipastor.png';

function Animals() {

    return (
        <section id="animales" className="scroller">
            <h3>Animales</h3>
            <div className="background">
                <article>
                    <img src={Dinomascoto} height={400} alt='Dinomascoto'/>
                    <div>
                        <h4>Parasaurolophus</h4>
                        <p>
                            ¡Cabalga a lomos de un poderoso Parasaurolophus! Escucha el tronar de sus cornamentas y siéntete un auténtico pionero del mundo prehistórico.
                        </p>
                    </div>
                </article>
            </div>
            <div className="background">
                <article>
                    <img src={Brachiosaurio} height={400} alt='Brachiosaurio'/>
                    <div>
                        <h4>Brachiosaurus</h4>
                        <p>
                            ¡Da comer a nuestros preciosos grandullones! Déjate saludar por estos gentiles colosos de la antigüedad.
                        </p>
                    </div>
                </article>
            </div>
            <div className="background">
                <article>
                    <img src={Triceratopodo} height={400} alt='Triceratopodo'/>
                    <div>
                        <h4>Styracosaurus</h4>
                        <p>
                            ¡Pasea en jeep junto a los imponentes styracosaurus! Los más exóticos de entre los cerátopos también tienen un hogar en el parque.
                        </p>
                    </div>
                </article>
            </div>
            <div className="background">
                <article>
                    <img src={Estegosaurio} height={400} alt='Estegosaurio'/>
                    <div>
                        <h4>Stegosaurus</h4>
                        <p>
                            ¡Acaricia las gigantescas crestas dorsales de estos pacíficos vegetasaurios! Podrás sentirte un auténtico susurrador de dinosaurios.
                        </p>
                    </div>
                </article>
            </div>
            <div className="background">
                <article>
                    <img src={Pterodactilo} height={400} alt='Pterodactilo'/>
                    <div>
                        <h4>Pterodactylus</h4>
                        <p>
                            ¡Fotografía los enormes nidos en nuestra Pajarera! Observa los vuelos rasantes y la pesca de sardina como nunca antes.
                        </p>
                    </div>
                </article>
            </div>
            <div className="background">
                <article>
                    <img src={AlejosaurioRex} height={400} alt='AlejosaurioRex'/>
                    <div>
                        <h4>Tyrannosaurus*</h4>
                        <p>
                            ¡Asómbrate con la máquina de destrucción más perfecta de la historia! Cronometra sus carreras y sé testigo de su poder.<br/>
                        </p>
                        <p className="small">*Alejosaurio es un término con copyright  del papa Alejo. Está prohibido su uso en todo el parque bajo pena de cárcel y multa.</p>
                    </div>
                </article>
            </div>
            <div className="background">
                <article>
                    <img className="Deinonychus" src={Deinonychus } height={400} alt='Deinonychus'/>
                    <div>
                        <h4>Deinonychus </h4>
                        <p>
                            ¡El inimitable! Terrorífico, mortal, veloz y carismático. No como su primo pequeño el Velociraptor. El Dinonychus te llegará al corazón, literalmente. <br/>
                            ¿Quieres un recuerdo de película? Pásate por la tienda del parque y consigue una de sus garras.
                        </p>
                    </div>
                </article>
            </div>
        </section>
    );
}

export default Animals;
